import { Action } from "shared/types/Action"

import { useAuthenticationActions } from "features/authentication/model/useAuthenticationActions"

import { AppSidebarProps } from "../AppSidebar"

export interface AppSidebarViewModel extends AppSidebarProps {
  authAction: Action
  hideHeader?: boolean
}

export function useAppSidebarViewModel(
  props: AppSidebarProps
): AppSidebarViewModel {
  const { userInfo, isLoadingUserInfo, onLogin, onLogout } = props

  const { loginAction, logoutAction } = useAuthenticationActions({
    idPrefix: "app-sidebar",
    login: onLogin,
    logout: onLogout,
    isLoginDisabled: isLoadingUserInfo,
    isLogoutDisabled: isLoadingUserInfo
  })

  return {
    ...props,
    authAction: userInfo ? logoutAction : loginAction
  }
}
